export default "__VITE_ASSET__puE554hQ__"